import React from "react";

//import resize function
import { vw, vh } from "../../../assets/reusableComponents/resizeFunction";

const PaymentConfirmationModal = ({
  isOpen,
  paymentId,
  onConfirm,
  onCancel,
  isReverse,
  onReverse,
}) => {
  if (!isOpen) return null;

  // Closes the modal if clicked outside of the modal content
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <>
      {isReverse ? (
        <>
          <div style={styles.overlay} onClick={handleOverlayClick}>
            <div style={styles.modal}>
              <h2 style={styles.header}>Reverse Payment</h2>
              <p style={styles.message}>
                Are you sure you want to reverse payment with ID:{" "}
                <strong>{paymentId}</strong>?
              </p>
              <div>
                <button style={{...styles.confirmButton,...styles.reverseButton}} onClick={onConfirm}>
                  Confirm
                </button>
                <button style={styles.cancelButton} onClick={onCancel}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div style={styles.overlay} onClick={handleOverlayClick}>
            <div style={styles.modal}>
              <h2 style={styles.header}>Confirm Payment</h2>
              <p style={styles.message}>
                Are you sure you want to approve payment with ID:{" "}
                <strong>{paymentId}</strong>?
              </p>
              <div>
                <button style={styles.confirmButton} onClick={onConfirm}>
                  Confirm
                </button>
                <button style={styles.cancelButton} onClick={onCancel}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  modal: {
    width: vw(400),
    padding: vh(20),
    backgroundColor: "#fff",
    borderRadius: vw(8),
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    textAlign: "center",
  },
  header: {
    fontSize: vh(20),
    marginBottom: "10px",
  },
  message: {
    fontSize: vh(16),
    marginBottom: vh(20),
  },

  confirmButton: {
    padding: vh(10),
    borderRadius: vw(5),
    border: "none",
    backgroundColor: "rgb(25, 42, 58)",
    color: "white",
    cursor: "pointer",
    width: "45%",
    transition: "background-color 0.3s",
    margin: "0px!important",
  },
  reverseButton: {
    backgroundColor: "#621b00",
  },
  cancelButton: {
    padding: vh(10),
    borderRadius: vw(5),
    border: "none",
    backgroundColor: "rgb(179, 147, 89)",
    color: "white",
    cursor: "pointer",
    width: "45%",
    transition: "background-color 0.3s",
    marginLeft: vw(10),
  },
};

export default PaymentConfirmationModal;
